import axiosInstance from "../../../api/axiosInstance";

export const fetchRegionImagesAPI = async () => {
  const imagesList = await axiosInstance.get("images/get-all-region-images");

  return imagesList.data;
};

export const uploadRegionImagesAPI = async (imageData) => {
  const uploadedImage = await axiosInstance.post(
    "images/upload-image",
    imageData
  );

  return uploadedImage.data;
};

export const deleteRegionImageAPI = async (id) => {
  const deleteImageId = await axiosInstance.delete(`images/delete-image/${id}`);

  return deleteImageId.data;
};
